export default "__VITE_ASSET__VC2Rt4DS__"